module.exports = __webpack_public_path__ + "static/Roboto-Bold-1c72f8e35e68191ff24f326ecb397a0b.woff";